module.exports = __webpack_public_path__ + "static/media/CroppedColumn.26d76808.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprites/CroppedColumn.png
// module id = 297
// module chunks = 0